import { MappedResponseContract } from '../DashboardSubpageRun/models';
import { MappedResponseQuote } from '../DashboardSubpageStudies/models';

export const handleSelectionAfterTableUpdate = (
  prevSelectedItems: string[],
  tableData: MappedResponseContract[] | MappedResponseQuote[],
  resetTableSelections: () => void
) => {
  const validIds = tableData.map((item) => item.offerId);
  const validSelectedIds = prevSelectedItems.filter((id) => validIds.includes(id));
  if (!validSelectedIds?.length) resetTableSelections();
  return validSelectedIds;
};
